import dayjs from "dayjs";

import { i18n } from "./i18n";

import "dayjs/locale/bg";

dayjs.locale(i18n.language);

export { dayjs };
